module.exports = __webpack_public_path__ + "assets/img/complaint_state_1.53b897aa.svg";